import React, { Component } from "react";
import { observer } from "mobx-react";

import CustomerListRow from "./CustomerListRow";

export default observer(
  class CustomerList extends Component {
    render() {
      const { customersStore, filter } = this.props;

      const filteredRows = customersStore.filter(
        r =>
          filter === "undefined" ||
          !filter ||
          (r.Name &&
            r.Name.toLowerCase().indexOf(filter.toLowerCase()) !== -1) ||
          (r.Email &&
            r.Email.toLowerCase().indexOf(filter.toLowerCase()) !== -1) ||
          (r.City &&
            r.City.toLowerCase().indexOf(filter.toLowerCase()) !== -1) ||
          (r.InternalRemark &&
            r.InternalRemark.toLowerCase().indexOf(filter.toLowerCase()) !== -1)
      );

      let rows = null;
      if (filteredRows) {
        rows = filteredRows.map(customer => {
          return <CustomerListRow key={customer.Id} customer={customer} />;
        });
      }

      return (
        <table className="table table-striped">
          <thead>
            <tr>
              <th className="col-sm-2">Name</th>
              <th className="col-sm-2">Telephone</th>
              <th className="col-sm-2">Email</th>
              <th className="col-sm-2">Internal remark</th>
              <th className="col-sm-1" />
              <th className="col-sm-1" />
              <th className="col-sm-1" />
              <th className="col-sm-1" />
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Components/CustomersList/index.js